class SpotlightPanels {
	constructor(spotlightPanelsRow) {
		this.row = spotlightPanelsRow;
		this.columnCount = this.detectColumnCount();
		this.columns = this.getColumns();
		this.accordionMediaQuery = window.matchMedia('(max-width: 640px)');
		this.tabletMediaQuery = window.matchMedia('(max-width: 1024px)');
		this.setupInteractions();
		this.init();
		this.handleBreakpointChange();
	}

	handleBreakpointChange() {
		[this.accordionMediaQuery, this.tabletMediaQuery].forEach((mediaQuery) => {
			mediaQuery.addEventListener('change', () => {
				this.destroyLayout();
				this.init();
			});
		});
	}

	destroyLayout() {
		this.row.style.display = '';
		this.row.style.flexWrap = '';
		this.row.style.gap = '';
	
		this.columns.forEach((column) => {
			column.style.flex = '';
			column.style.marginLeft = '';
			column.style.marginRight = '';
			column.style.paddingLeft = '';
			column.style.paddingRight = '';
			column.style.width = '';
			column.style.maxWidth = '';
			column.style.transition = '';
			column.classList.remove('block-spotlight-panels__col--content-visible');
		});
	}

	detectColumnCount() {
		// Check for class indicators first
		if (this.row.classList.contains('block-spotlight-panels__row--1cols')) return 1;
		if (this.row.classList.contains('block-spotlight-panels__row--2cols')) return 2;
		if (this.row.classList.contains('block-spotlight-panels__row--3cols')) return 3;
		if (this.row.classList.contains('block-spotlight-panels__row--4cols')) return 4;

		// Fallback: count columns by checking for Foundation grid classes
		const colsMedium12 = this.row.querySelectorAll('.columns.medium-12').length;
		const colsMedium6 = this.row.querySelectorAll('.columns.medium-6').length;
		const colsMedium4 = this.row.querySelectorAll('.columns.medium-4').length;
		const colsMedium3 = this.row.querySelectorAll('.columns.medium-3').length;

		if (colsMedium12 === 1) return 1;
		if (colsMedium6 === 2) return 2;
		if (colsMedium4 === 3) return 3;
		if (colsMedium3 === 4) return 4;

		// Count all columns
		const allCols = this.row.querySelectorAll('.block-spotlight-panels__col').length;
		return allCols;
	}

	getColumns() {
		return this.row.querySelectorAll('.block-spotlight-panels__col');
	}

	init() {

		if (this.accordionMediaQuery.matches) {
			this.destroyLayout();
			return;
		}

		// Only apply to background-image style with 1-4 columns
		if (!this.row.classList.contains('block-spotlight-panels--style-background-image')) {
			return;
		}

		if (this.columnCount < 1 || this.columnCount > 4) {
			return;
		}

		if (this.columns.length !== this.columnCount) {
			return;
		}

		if (this.tabletMediaQuery.matches) {
			return;
		}

		// Keep every panel at an equal width and reveal its content on hover
		this.applyLayout(this.columnCount);
	}

	applyLayout(count) {
		// Set row to flexbox with a 10px gap between panels
		this.row.style.display = 'flex';
		this.row.style.flexWrap = 'nowrap';
		this.row.style.gap = '1rem';

		// Calculate default width based on column count
		const defaultWidth = 100 / count;

		// Reset all columns to equal width
		this.columns.forEach((column) => {
			column.style.flex = `1 1 ${defaultWidth}%`;
			column.style.marginLeft = '0';
			column.style.marginRight = '0';
			column.style.paddingLeft = '0';
			column.style.paddingRight = '0';
			column.style.width = 'auto';
			column.style.maxWidth = 'none';
		});
	}

	setupInteractions() {
		this.columns.forEach((column) => {
			column.addEventListener('mouseenter', () => {
				if (this.accordionMediaQuery.matches) {
					return;
				}

				column.classList.add('block-spotlight-panels__col--content-visible');
			});

			column.addEventListener('mouseleave', () => {
				if (this.accordionMediaQuery.matches) {
					return;
				}

				column.classList.remove('block-spotlight-panels__col--content-visible');
			});

			column.addEventListener('click', (event) => {
				if (!this.accordionMediaQuery.matches) {
					return;
				}

				const isOpen = column.classList.contains('block-spotlight-panels__col--content-visible');
				const isButton = event.target.closest('.block-spotlight-panels__button');

				if (isOpen && isButton) {
					return;
				}

				event.preventDefault();

				this.columns.forEach((item) => {
					const wrapper = item.querySelector('.block-spotlight-panels__content-wrapper');

					item.classList.remove('block-spotlight-panels__col--content-visible');

					if (wrapper) {
						wrapper.style.height = 'auto';
					}
				});

				if (!isOpen) {
					column.classList.add('block-spotlight-panels__col--content-visible');
				}
			});
		});
	}
}

export default SpotlightPanels;
